import { createFileRoute } from "@tanstack/react-router";

import { PraxaAgentCatalog } from "../components/praxa/PraxaAgentCatalogSurface";

export const Route = createFileRoute("/w/$workspaceId/agents/")({
  component: PraxaAgentsRoute,
});

function PraxaAgentsRoute() {
  const { workspaceId } = Route.useParams();
  return <PraxaAgentCatalog workspaceId={workspaceId} />;
}
